// extracted by mini-css-extract-plugin
module.exports = {"mfcontainer":"Microfrontend--mfcontainer--3uGm7"};